import { Fragment, useState } from 'react'
import styled, { css } from 'styled-components'

const StyledList = styled.div`
	ul {
		list-style: none;
		li {
			position: relative;
			padding-left: 16px;
			${props =>
				props.listType === 'activities' &&
				css`
					display: block;
				`} &:before {
				content: '';
				background-color: #c4c4c4;
				width: 7px;
				height: 7px;
				border: 0;
				top: 9px;
				position: absolute;
				left: 0;
				border-radius: 100%;
				background-clip: padding-box;
			}
		}
	}
`

const ShowMoreText = styled.span`
	font-size: 17px;
	line-height: 21px;
	color: #999999;
`

export const ListWithShowMore = ({
	minShow = 2,
	dataList = [],
	type = '',
	enableShowMore,
	onCardClick = () => {},
}) => {
	const [itemsToShow, setItemsToShow] = useState(minShow)

	const toggleDataToShow = e => {
		e && e.preventDefault()
		e && e.stopPropagation()
		if (itemsToShow === minShow) {
			setItemsToShow(dataList.length)
		} else {
			setItemsToShow(minShow)
		}
	}

	const dataToShow = dataList.slice(0, itemsToShow)
	const postText =
		dataList.length <= minShow
			? ''
			: itemsToShow === minShow
			? ` +${dataList.length - itemsToShow} ${type}`
			: ' -show less'

	return (
		<StyledList listType={type}>
			<ul>
				{dataToShow.map((item, idx) => {
					return (
						<Fragment key={idx}>
							<li>
								{item}
								{idx + 1 === itemsToShow && (
									<ShowMoreText
										onClick={enableShowMore ? toggleDataToShow : onCardClick}
									>
										{postText}
									</ShowMoreText>
								)}
							</li>
						</Fragment>
					)
				})}
			</ul>
		</StyledList>
	)
}
